import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, UseMutationOptions } from 'react-query';
import { useCodegenFetcher } from '../../codeGenFetcher';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'


export const GetProtocolDetailsDocument = /*#__PURE__*/ `
    query getProtocolDetails($protocolId: ID!) {
  protocol(protocolId: $protocolId) {
    id
    versions {
      id
      name
      status
      schedules {
        id
        name
        visits {
          anchor {
            crossVersionId
            id
            name
            track
            type
          }
          crossVersionId
          id
          name
          track
          type
        }
      }
    }
  }
}
    `;

export const useGetProtocolDetailsQuery = <
      TData = IGetProtocolDetailsQuery,
      TError = unknown
    >(
      variables: IGetProtocolDetailsQueryVariables,
      options?: UseQueryOptions<IGetProtocolDetailsQuery, TError, TData>
    ) => {
    
    return useQuery<IGetProtocolDetailsQuery, TError, TData>(
      ['getProtocolDetails', variables],
      useCodegenFetcher<IGetProtocolDetailsQuery, IGetProtocolDetailsQueryVariables>(GetProtocolDetailsDocument).bind(null, variables),
      options
    )};

useGetProtocolDetailsQuery.getKey = (variables: IGetProtocolDetailsQueryVariables) => ['getProtocolDetails', variables];

export const useInfiniteGetProtocolDetailsQuery = <
      TData = IGetProtocolDetailsQuery,
      TError = unknown
    >(
      variables: IGetProtocolDetailsQueryVariables,
      options?: UseInfiniteQueryOptions<IGetProtocolDetailsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IGetProtocolDetailsQuery, IGetProtocolDetailsQueryVariables>(GetProtocolDetailsDocument)
    return useInfiniteQuery<IGetProtocolDetailsQuery, TError, TData>(
      ['getProtocolDetails.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteGetProtocolDetailsQuery.getKey = (variables: IGetProtocolDetailsQueryVariables) => ['getProtocolDetails.infinite', variables];

export const GetSourceDocumentsDocument = /*#__PURE__*/ `
    query getSourceDocuments($listSourceDocumentsInput: ListSourceDocumentsInput!) {
  listSourceDocuments(input: $listSourceDocumentsInput) {
    edges {
      node {
        patientVisits {
          __typename
          id
          type
          ... on PatientProtocolVisit {
            __typename
            protocolVisit {
              track
              name
              crossVersionId
              visitWindow {
                fromDate
                toDate
                targetDate
              }
              scheduled {
                visitId
                date
              }
            }
          }
          ... on UnscheduledPatientProtocolVisit {
            __typename
            name
            track
            date
          }
        }
        id
        authors {
          id
          fullName
          email
        }
        siteTrialPatient {
          id
          subjectId
        }
        filledInForm {
          id
        }
        reviewer {
          id
          fullName
          email
        }
        revisionAssignee {
          id
          fullName
          email
        }
        uploadedAt
        updatedAt
        originalDate
        name
        closedQueriesCount
        confirmed
        createdAt
        fileSize
        openQueriesCount
        originalDate
        piSignatureRequired
        piSigned
        piSignatureInvalidated
        piUpdatesRequested
        qcWorkflowStatus
        uploadedAt
        pageCount
        partial
        signed
        status
        trialSource
        type
        version
        workflowAge
        workflowStatus
        arn
        lifeCycleStatus
        checksum
        uploader {
          id
          fullName
          email
        }
      }
    }
    page {
      next
      hasNextPage
    }
  }
}
    `;

export const useGetSourceDocumentsQuery = <
      TData = IGetSourceDocumentsQuery,
      TError = unknown
    >(
      variables: IGetSourceDocumentsQueryVariables,
      options?: UseQueryOptions<IGetSourceDocumentsQuery, TError, TData>
    ) => {
    
    return useQuery<IGetSourceDocumentsQuery, TError, TData>(
      ['getSourceDocuments', variables],
      useCodegenFetcher<IGetSourceDocumentsQuery, IGetSourceDocumentsQueryVariables>(GetSourceDocumentsDocument).bind(null, variables),
      options
    )};

useGetSourceDocumentsQuery.getKey = (variables: IGetSourceDocumentsQueryVariables) => ['getSourceDocuments', variables];

export const useInfiniteGetSourceDocumentsQuery = <
      TData = IGetSourceDocumentsQuery,
      TError = unknown
    >(
      variables: IGetSourceDocumentsQueryVariables,
      options?: UseInfiniteQueryOptions<IGetSourceDocumentsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IGetSourceDocumentsQuery, IGetSourceDocumentsQueryVariables>(GetSourceDocumentsDocument)
    return useInfiniteQuery<IGetSourceDocumentsQuery, TError, TData>(
      ['getSourceDocuments.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteGetSourceDocumentsQuery.getKey = (variables: IGetSourceDocumentsQueryVariables) => ['getSourceDocuments.infinite', variables];

export const GetSiteTrialPatientProtocolVisitsDocument = /*#__PURE__*/ `
    query getSiteTrialPatientProtocolVisits($request: Site__GetSiteTrialPatientProtocolVisitsRequest!, $siteTrialPatientId: ID!) {
  Site__GetSiteTrialPatientProtocolVisits(request: $request) {
    protocol {
      id
      versions {
        id
        active
        name
        schedule {
          id
        }
        patientVisits(siteTrialPatientId: $siteTrialPatientId) {
          __typename
          versionVisitId
          crossVersionId
          name
          track
          scheduled {
            visitId
            date
          }
          window {
            fromDate
            toDate
            targetDate
          }
          documentNames
          patientVisit {
            id
          }
        }
        patientUnscheduledVisits(siteTrialPatientId: $siteTrialPatientId) {
          __typename
          visitId
          date
          id
          name
          track
          patientVisit {
            id
          }
        }
      }
    }
  }
}
    `;

export const useGetSiteTrialPatientProtocolVisitsQuery = <
      TData = IGetSiteTrialPatientProtocolVisitsQuery,
      TError = unknown
    >(
      variables: IGetSiteTrialPatientProtocolVisitsQueryVariables,
      options?: UseQueryOptions<IGetSiteTrialPatientProtocolVisitsQuery, TError, TData>
    ) => {
    
    return useQuery<IGetSiteTrialPatientProtocolVisitsQuery, TError, TData>(
      ['getSiteTrialPatientProtocolVisits', variables],
      useCodegenFetcher<IGetSiteTrialPatientProtocolVisitsQuery, IGetSiteTrialPatientProtocolVisitsQueryVariables>(GetSiteTrialPatientProtocolVisitsDocument).bind(null, variables),
      options
    )};

useGetSiteTrialPatientProtocolVisitsQuery.getKey = (variables: IGetSiteTrialPatientProtocolVisitsQueryVariables) => ['getSiteTrialPatientProtocolVisits', variables];

export const useInfiniteGetSiteTrialPatientProtocolVisitsQuery = <
      TData = IGetSiteTrialPatientProtocolVisitsQuery,
      TError = unknown
    >(
      variables: IGetSiteTrialPatientProtocolVisitsQueryVariables,
      options?: UseInfiniteQueryOptions<IGetSiteTrialPatientProtocolVisitsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IGetSiteTrialPatientProtocolVisitsQuery, IGetSiteTrialPatientProtocolVisitsQueryVariables>(GetSiteTrialPatientProtocolVisitsDocument)
    return useInfiniteQuery<IGetSiteTrialPatientProtocolVisitsQuery, TError, TData>(
      ['getSiteTrialPatientProtocolVisits.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteGetSiteTrialPatientProtocolVisitsQuery.getKey = (variables: IGetSiteTrialPatientProtocolVisitsQueryVariables) => ['getSiteTrialPatientProtocolVisits.infinite', variables];

export const BulkCheckPermissionsDocument = /*#__PURE__*/ `
    query BulkCheckPermissions($input: BulkCheckPermissionsInput!) {
  bulkCheckPermissions(input: $input) {
    checks {
      canAccess
      permission
      resource(allSiteTrials: true) {
        __typename
        ... on SiteTrial {
          studyteamId
        }
      }
    }
  }
}
    `;

export const useBulkCheckPermissionsQuery = <
      TData = IBulkCheckPermissionsQuery,
      TError = unknown
    >(
      variables: IBulkCheckPermissionsQueryVariables,
      options?: UseQueryOptions<IBulkCheckPermissionsQuery, TError, TData>
    ) => {
    
    return useQuery<IBulkCheckPermissionsQuery, TError, TData>(
      ['BulkCheckPermissions', variables],
      useCodegenFetcher<IBulkCheckPermissionsQuery, IBulkCheckPermissionsQueryVariables>(BulkCheckPermissionsDocument).bind(null, variables),
      options
    )};

useBulkCheckPermissionsQuery.getKey = (variables: IBulkCheckPermissionsQueryVariables) => ['BulkCheckPermissions', variables];

export const useInfiniteBulkCheckPermissionsQuery = <
      TData = IBulkCheckPermissionsQuery,
      TError = unknown
    >(
      variables: IBulkCheckPermissionsQueryVariables,
      options?: UseInfiniteQueryOptions<IBulkCheckPermissionsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IBulkCheckPermissionsQuery, IBulkCheckPermissionsQueryVariables>(BulkCheckPermissionsDocument)
    return useInfiniteQuery<IBulkCheckPermissionsQuery, TError, TData>(
      ['BulkCheckPermissions.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteBulkCheckPermissionsQuery.getKey = (variables: IBulkCheckPermissionsQueryVariables) => ['BulkCheckPermissions.infinite', variables];

export const DocumentLogDocument = /*#__PURE__*/ `
    query DocumentLog($input: DocumentLogInput) {
  documentLog(input: $input) {
    logEntries {
      updatedBy {
        fullName
        email
        id
      }
      updatedAt
      reason
      documentVersion
      description
      action
      changes {
        __typename
        ... on ChangedDocumentName {
          oldDocumentName: oldValue
          newDocumentName: newValue
        }
        ... on ChangedOriginalDate {
          oldOriginalDate: oldValue
          newOriginalDate: newValue
        }
        ... on ChangedPatientVisits {
          oldPatientVisits: oldValue {
            __typename
            ... on PatientProtocolVisit {
              protocolVisit {
                name
              }
            }
            ... on UnscheduledPatientProtocolVisit {
              name
            }
          }
          newPatientVisits: newValue {
            __typename
            ... on PatientProtocolVisit {
              protocolVisit {
                name
              }
            }
            ... on UnscheduledPatientProtocolVisit {
              name
            }
          }
        }
        ... on ChangedNote {
          oldNote: oldValue
          newNote: newValue
        }
        ... on ChangedSiteTrialPatient {
          newSiteTrialPatient: newValue {
            subjectId
          }
          oldSiteTrialPatient: oldValue {
            subjectId
          }
        }
      }
    }
  }
}
    `;

export const useDocumentLogQuery = <
      TData = IDocumentLogQuery,
      TError = unknown
    >(
      variables?: IDocumentLogQueryVariables,
      options?: UseQueryOptions<IDocumentLogQuery, TError, TData>
    ) => {
    
    return useQuery<IDocumentLogQuery, TError, TData>(
      variables === undefined ? ['DocumentLog'] : ['DocumentLog', variables],
      useCodegenFetcher<IDocumentLogQuery, IDocumentLogQueryVariables>(DocumentLogDocument).bind(null, variables),
      options
    )};

useDocumentLogQuery.getKey = (variables?: IDocumentLogQueryVariables) => variables === undefined ? ['DocumentLog'] : ['DocumentLog', variables];

export const useInfiniteDocumentLogQuery = <
      TData = IDocumentLogQuery,
      TError = unknown
    >(
      variables?: IDocumentLogQueryVariables,
      options?: UseInfiniteQueryOptions<IDocumentLogQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IDocumentLogQuery, IDocumentLogQueryVariables>(DocumentLogDocument)
    return useInfiniteQuery<IDocumentLogQuery, TError, TData>(
      variables === undefined ? ['DocumentLog.infinite'] : ['DocumentLog.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteDocumentLogQuery.getKey = (variables?: IDocumentLogQueryVariables) => variables === undefined ? ['DocumentLog.infinite'] : ['DocumentLog.infinite', variables];

export const EdoaUserProfileDocument = /*#__PURE__*/ `
    query EdoaUserProfile {
  edoaUserProfile {
    fullName
    role
    trialAccess {
      trial {
        stId
      }
      isPi
      delegationCount
    }
  }
}
    `;

export const useEdoaUserProfileQuery = <
      TData = IEdoaUserProfileQuery,
      TError = unknown
    >(
      variables?: IEdoaUserProfileQueryVariables,
      options?: UseQueryOptions<IEdoaUserProfileQuery, TError, TData>
    ) => {
    
    return useQuery<IEdoaUserProfileQuery, TError, TData>(
      variables === undefined ? ['EdoaUserProfile'] : ['EdoaUserProfile', variables],
      useCodegenFetcher<IEdoaUserProfileQuery, IEdoaUserProfileQueryVariables>(EdoaUserProfileDocument).bind(null, variables),
      options
    )};

useEdoaUserProfileQuery.getKey = (variables?: IEdoaUserProfileQueryVariables) => variables === undefined ? ['EdoaUserProfile'] : ['EdoaUserProfile', variables];

export const useInfiniteEdoaUserProfileQuery = <
      TData = IEdoaUserProfileQuery,
      TError = unknown
    >(
      variables?: IEdoaUserProfileQueryVariables,
      options?: UseInfiniteQueryOptions<IEdoaUserProfileQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IEdoaUserProfileQuery, IEdoaUserProfileQueryVariables>(EdoaUserProfileDocument)
    return useInfiniteQuery<IEdoaUserProfileQuery, TError, TData>(
      variables === undefined ? ['EdoaUserProfile.infinite'] : ['EdoaUserProfile.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteEdoaUserProfileQuery.getKey = (variables?: IEdoaUserProfileQueryVariables) => variables === undefined ? ['EdoaUserProfile.infinite'] : ['EdoaUserProfile.infinite', variables];

export const ListExpectedUploadDocument = /*#__PURE__*/ `
    query ListExpectedUpload($req: ListExpectedSourceDocumentUploadsInput!) {
  listExpectedDocumentUploads(input: $req) {
    expectedUploads {
      documentName
      expectedUploadDate
      expectedUploadDateTimezone
      id
      documents {
        id
      }
    }
  }
}
    `;

export const useListExpectedUploadQuery = <
      TData = IListExpectedUploadQuery,
      TError = unknown
    >(
      variables: IListExpectedUploadQueryVariables,
      options?: UseQueryOptions<IListExpectedUploadQuery, TError, TData>
    ) => {
    
    return useQuery<IListExpectedUploadQuery, TError, TData>(
      ['ListExpectedUpload', variables],
      useCodegenFetcher<IListExpectedUploadQuery, IListExpectedUploadQueryVariables>(ListExpectedUploadDocument).bind(null, variables),
      options
    )};

useListExpectedUploadQuery.getKey = (variables: IListExpectedUploadQueryVariables) => ['ListExpectedUpload', variables];

export const useInfiniteListExpectedUploadQuery = <
      TData = IListExpectedUploadQuery,
      TError = unknown
    >(
      variables: IListExpectedUploadQueryVariables,
      options?: UseInfiniteQueryOptions<IListExpectedUploadQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IListExpectedUploadQuery, IListExpectedUploadQueryVariables>(ListExpectedUploadDocument)
    return useInfiniteQuery<IListExpectedUploadQuery, TError, TData>(
      ['ListExpectedUpload.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteListExpectedUploadQuery.getKey = (variables: IListExpectedUploadQueryVariables) => ['ListExpectedUpload.infinite', variables];

export const GetAllSourceDocumentsForSiteTrialPatientDocument = /*#__PURE__*/ `
    query getAllSourceDocumentsForSiteTrialPatient($input: ListSourceDocumentsInput!) {
  listSourceDocuments(input: $input) {
    edges {
      node {
        id
        name
        type
        uploadedAt
        filledInForm {
          id
          partial
          version
          blankForm {
            id
            name
            version
            versionLabel
            options {
              continuous
            }
          }
        }
        patientVisits {
          id
          type
          ... on PatientProtocolVisit {
            protocolVisit {
              track
              name
              crossVersionId
            }
          }
          ... on UnscheduledPatientProtocolVisit {
            name
            track
          }
        }
      }
    }
  }
}
    `;

export const useGetAllSourceDocumentsForSiteTrialPatientQuery = <
      TData = IGetAllSourceDocumentsForSiteTrialPatientQuery,
      TError = unknown
    >(
      variables: IGetAllSourceDocumentsForSiteTrialPatientQueryVariables,
      options?: UseQueryOptions<IGetAllSourceDocumentsForSiteTrialPatientQuery, TError, TData>
    ) => {
    
    return useQuery<IGetAllSourceDocumentsForSiteTrialPatientQuery, TError, TData>(
      ['getAllSourceDocumentsForSiteTrialPatient', variables],
      useCodegenFetcher<IGetAllSourceDocumentsForSiteTrialPatientQuery, IGetAllSourceDocumentsForSiteTrialPatientQueryVariables>(GetAllSourceDocumentsForSiteTrialPatientDocument).bind(null, variables),
      options
    )};

useGetAllSourceDocumentsForSiteTrialPatientQuery.getKey = (variables: IGetAllSourceDocumentsForSiteTrialPatientQueryVariables) => ['getAllSourceDocumentsForSiteTrialPatient', variables];

export const useInfiniteGetAllSourceDocumentsForSiteTrialPatientQuery = <
      TData = IGetAllSourceDocumentsForSiteTrialPatientQuery,
      TError = unknown
    >(
      variables: IGetAllSourceDocumentsForSiteTrialPatientQueryVariables,
      options?: UseInfiniteQueryOptions<IGetAllSourceDocumentsForSiteTrialPatientQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IGetAllSourceDocumentsForSiteTrialPatientQuery, IGetAllSourceDocumentsForSiteTrialPatientQueryVariables>(GetAllSourceDocumentsForSiteTrialPatientDocument)
    return useInfiniteQuery<IGetAllSourceDocumentsForSiteTrialPatientQuery, TError, TData>(
      ['getAllSourceDocumentsForSiteTrialPatient.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteGetAllSourceDocumentsForSiteTrialPatientQuery.getKey = (variables: IGetAllSourceDocumentsForSiteTrialPatientQueryVariables) => ['getAllSourceDocumentsForSiteTrialPatient.infinite', variables];

export const GetPiSignatureCountsDocument = /*#__PURE__*/ `
    query getPISignatureCounts($input: SignatureRequiredCountInput!) {
  signatureRequiredCount(input: $input) {
    awaitingSignature
    signatureInvalidated
  }
}
    `;

export const useGetPiSignatureCountsQuery = <
      TData = IGetPiSignatureCountsQuery,
      TError = unknown
    >(
      variables: IGetPiSignatureCountsQueryVariables,
      options?: UseQueryOptions<IGetPiSignatureCountsQuery, TError, TData>
    ) => {
    
    return useQuery<IGetPiSignatureCountsQuery, TError, TData>(
      ['getPISignatureCounts', variables],
      useCodegenFetcher<IGetPiSignatureCountsQuery, IGetPiSignatureCountsQueryVariables>(GetPiSignatureCountsDocument).bind(null, variables),
      options
    )};

useGetPiSignatureCountsQuery.getKey = (variables: IGetPiSignatureCountsQueryVariables) => ['getPISignatureCounts', variables];

export const useInfiniteGetPiSignatureCountsQuery = <
      TData = IGetPiSignatureCountsQuery,
      TError = unknown
    >(
      variables: IGetPiSignatureCountsQueryVariables,
      options?: UseInfiniteQueryOptions<IGetPiSignatureCountsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IGetPiSignatureCountsQuery, IGetPiSignatureCountsQueryVariables>(GetPiSignatureCountsDocument)
    return useInfiniteQuery<IGetPiSignatureCountsQuery, TError, TData>(
      ['getPISignatureCounts.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteGetPiSignatureCountsQuery.getKey = (variables: IGetPiSignatureCountsQueryVariables) => ['getPISignatureCounts.infinite', variables];

export const GetSiteTrialDetailsDocument = /*#__PURE__*/ `
    query getSiteTrialDetails($input: QuerySiteTrialInput!) {
  siteTrial(input: $input) {
    id
    name
    siteNumber
    sponsor {
      name
    }
    sponsorTrial(allTrials: true) {
      stId
      name
    }
  }
}
    `;

export const useGetSiteTrialDetailsQuery = <
      TData = IGetSiteTrialDetailsQuery,
      TError = unknown
    >(
      variables: IGetSiteTrialDetailsQueryVariables,
      options?: UseQueryOptions<IGetSiteTrialDetailsQuery, TError, TData>
    ) => {
    
    return useQuery<IGetSiteTrialDetailsQuery, TError, TData>(
      ['getSiteTrialDetails', variables],
      useCodegenFetcher<IGetSiteTrialDetailsQuery, IGetSiteTrialDetailsQueryVariables>(GetSiteTrialDetailsDocument).bind(null, variables),
      options
    )};

useGetSiteTrialDetailsQuery.getKey = (variables: IGetSiteTrialDetailsQueryVariables) => ['getSiteTrialDetails', variables];

export const useInfiniteGetSiteTrialDetailsQuery = <
      TData = IGetSiteTrialDetailsQuery,
      TError = unknown
    >(
      variables: IGetSiteTrialDetailsQueryVariables,
      options?: UseInfiniteQueryOptions<IGetSiteTrialDetailsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IGetSiteTrialDetailsQuery, IGetSiteTrialDetailsQueryVariables>(GetSiteTrialDetailsDocument)
    return useInfiniteQuery<IGetSiteTrialDetailsQuery, TError, TData>(
      ['getSiteTrialDetails.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteGetSiteTrialDetailsQuery.getKey = (variables: IGetSiteTrialDetailsQueryVariables) => ['getSiteTrialDetails.infinite', variables];

export const GetSiteTrialPatientProtocolVisitsForSiteTrialDocument = /*#__PURE__*/ `
    query getSiteTrialPatientProtocolVisitsForSiteTrial($request: Site__GetSiteTrialPatientProtocolVisitsForSiteTrialRequest!) {
  data: Site__GetSiteTrialPatientProtocolVisitsForSiteTrial(request: $request) {
    patientVisits {
      id
      __typename
      siteTrialPatient {
        id
        subjectId
        sitePatient {
          patient {
            name
          }
        }
      }
      type
      sourceData {
        progressPercentage
      }
      ... on PatientProtocolVisit {
        protocolVisit {
          name
          crossVersionId
          scheduled {
            date
            visitId
          }
          visitWindow {
            fromDate
            targetDate
            toDate
          }
        }
        protocolVersion {
          name
        }
        versionVisitId
      }
      ... on UnscheduledPatientProtocolVisit {
        name
        date
        visitId
        protocolVersion {
          name
        }
      }
    }
  }
}
    `;

export const useGetSiteTrialPatientProtocolVisitsForSiteTrialQuery = <
      TData = IGetSiteTrialPatientProtocolVisitsForSiteTrialQuery,
      TError = unknown
    >(
      variables: IGetSiteTrialPatientProtocolVisitsForSiteTrialQueryVariables,
      options?: UseQueryOptions<IGetSiteTrialPatientProtocolVisitsForSiteTrialQuery, TError, TData>
    ) => {
    
    return useQuery<IGetSiteTrialPatientProtocolVisitsForSiteTrialQuery, TError, TData>(
      ['getSiteTrialPatientProtocolVisitsForSiteTrial', variables],
      useCodegenFetcher<IGetSiteTrialPatientProtocolVisitsForSiteTrialQuery, IGetSiteTrialPatientProtocolVisitsForSiteTrialQueryVariables>(GetSiteTrialPatientProtocolVisitsForSiteTrialDocument).bind(null, variables),
      options
    )};

useGetSiteTrialPatientProtocolVisitsForSiteTrialQuery.getKey = (variables: IGetSiteTrialPatientProtocolVisitsForSiteTrialQueryVariables) => ['getSiteTrialPatientProtocolVisitsForSiteTrial', variables];

export const useInfiniteGetSiteTrialPatientProtocolVisitsForSiteTrialQuery = <
      TData = IGetSiteTrialPatientProtocolVisitsForSiteTrialQuery,
      TError = unknown
    >(
      variables: IGetSiteTrialPatientProtocolVisitsForSiteTrialQueryVariables,
      options?: UseInfiniteQueryOptions<IGetSiteTrialPatientProtocolVisitsForSiteTrialQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IGetSiteTrialPatientProtocolVisitsForSiteTrialQuery, IGetSiteTrialPatientProtocolVisitsForSiteTrialQueryVariables>(GetSiteTrialPatientProtocolVisitsForSiteTrialDocument)
    return useInfiniteQuery<IGetSiteTrialPatientProtocolVisitsForSiteTrialQuery, TError, TData>(
      ['getSiteTrialPatientProtocolVisitsForSiteTrial.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteGetSiteTrialPatientProtocolVisitsForSiteTrialQuery.getKey = (variables: IGetSiteTrialPatientProtocolVisitsForSiteTrialQueryVariables) => ['getSiteTrialPatientProtocolVisitsForSiteTrial.infinite', variables];

export const GetSiteTrialPatientProtocolVisitsForSiteTrialByCraDocument = /*#__PURE__*/ `
    query getSiteTrialPatientProtocolVisitsForSiteTrialByCRA($request: Site__GetSiteTrialPatientProtocolVisitsForSiteTrialRequest!) {
  data: Site__GetSiteTrialPatientProtocolVisitsForSiteTrial(request: $request) {
    patientVisits {
      id
      __typename
      siteTrialPatient {
        id
        subjectId
      }
      type
      sourceData {
        progressPercentage
      }
      ... on PatientProtocolVisit {
        protocolVisit {
          name
          crossVersionId
          scheduled {
            date
            visitId
          }
          visitWindow {
            fromDate
            targetDate
            toDate
          }
        }
        protocolVersion {
          name
        }
        versionVisitId
      }
      ... on UnscheduledPatientProtocolVisit {
        name
        date
        visitId
        protocolVersion {
          name
        }
      }
    }
  }
}
    `;

export const useGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery = <
      TData = IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery,
      TError = unknown
    >(
      variables: IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQueryVariables,
      options?: UseQueryOptions<IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery, TError, TData>
    ) => {
    
    return useQuery<IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery, TError, TData>(
      ['getSiteTrialPatientProtocolVisitsForSiteTrialByCRA', variables],
      useCodegenFetcher<IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery, IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQueryVariables>(GetSiteTrialPatientProtocolVisitsForSiteTrialByCraDocument).bind(null, variables),
      options
    )};

useGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery.getKey = (variables: IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQueryVariables) => ['getSiteTrialPatientProtocolVisitsForSiteTrialByCRA', variables];

export const useInfiniteGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery = <
      TData = IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery,
      TError = unknown
    >(
      variables: IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQueryVariables,
      options?: UseInfiniteQueryOptions<IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery, IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQueryVariables>(GetSiteTrialPatientProtocolVisitsForSiteTrialByCraDocument)
    return useInfiniteQuery<IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery, TError, TData>(
      ['getSiteTrialPatientProtocolVisitsForSiteTrialByCRA.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery.getKey = (variables: IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQueryVariables) => ['getSiteTrialPatientProtocolVisitsForSiteTrialByCRA.infinite', variables];

export const ListBlankFormSetsDocument = /*#__PURE__*/ `
    query listBlankFormSets($input: ListBlankFormSetsInput!) {
  listBlankFormSets(input: $input) {
    type
    blankFormsWithMeta {
      piSignatureRequired
      blankForm {
        id
        name
        versionLabel
        options {
          continuous
        }
      }
    }
  }
}
    `;

export const useListBlankFormSetsQuery = <
      TData = IListBlankFormSetsQuery,
      TError = unknown
    >(
      variables: IListBlankFormSetsQueryVariables,
      options?: UseQueryOptions<IListBlankFormSetsQuery, TError, TData>
    ) => {
    
    return useQuery<IListBlankFormSetsQuery, TError, TData>(
      ['listBlankFormSets', variables],
      useCodegenFetcher<IListBlankFormSetsQuery, IListBlankFormSetsQueryVariables>(ListBlankFormSetsDocument).bind(null, variables),
      options
    )};

useListBlankFormSetsQuery.getKey = (variables: IListBlankFormSetsQueryVariables) => ['listBlankFormSets', variables];

export const useInfiniteListBlankFormSetsQuery = <
      TData = IListBlankFormSetsQuery,
      TError = unknown
    >(
      variables: IListBlankFormSetsQueryVariables,
      options?: UseInfiniteQueryOptions<IListBlankFormSetsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IListBlankFormSetsQuery, IListBlankFormSetsQueryVariables>(ListBlankFormSetsDocument)
    return useInfiniteQuery<IListBlankFormSetsQuery, TError, TData>(
      ['listBlankFormSets.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteListBlankFormSetsQuery.getKey = (variables: IListBlankFormSetsQueryVariables) => ['listBlankFormSets.infinite', variables];

export const ListRoleAssignmentsDocument = /*#__PURE__*/ `
    query listRoleAssignments($userId: ID!) {
  user(userId: $userId) {
    roleAssignments {
      resourceType
      role {
        name
      }
      resourceId
      roleId
    }
  }
}
    `;

export const useListRoleAssignmentsQuery = <
      TData = IListRoleAssignmentsQuery,
      TError = unknown
    >(
      variables: IListRoleAssignmentsQueryVariables,
      options?: UseQueryOptions<IListRoleAssignmentsQuery, TError, TData>
    ) => {
    
    return useQuery<IListRoleAssignmentsQuery, TError, TData>(
      ['listRoleAssignments', variables],
      useCodegenFetcher<IListRoleAssignmentsQuery, IListRoleAssignmentsQueryVariables>(ListRoleAssignmentsDocument).bind(null, variables),
      options
    )};

useListRoleAssignmentsQuery.getKey = (variables: IListRoleAssignmentsQueryVariables) => ['listRoleAssignments', variables];

export const useInfiniteListRoleAssignmentsQuery = <
      TData = IListRoleAssignmentsQuery,
      TError = unknown
    >(
      variables: IListRoleAssignmentsQueryVariables,
      options?: UseInfiniteQueryOptions<IListRoleAssignmentsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IListRoleAssignmentsQuery, IListRoleAssignmentsQueryVariables>(ListRoleAssignmentsDocument)
    return useInfiniteQuery<IListRoleAssignmentsQuery, TError, TData>(
      ['listRoleAssignments.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteListRoleAssignmentsQuery.getKey = (variables: IListRoleAssignmentsQueryVariables) => ['listRoleAssignments.infinite', variables];

export const ListFgaRolesDocument = /*#__PURE__*/ `
    query listFGARoles {
  Fga__listRoles {
    roles {
      metadata {
        products
      }
      permissions {
        id
        name
      }
      name
      id
    }
  }
}
    `;

export const useListFgaRolesQuery = <
      TData = IListFgaRolesQuery,
      TError = unknown
    >(
      variables?: IListFgaRolesQueryVariables,
      options?: UseQueryOptions<IListFgaRolesQuery, TError, TData>
    ) => {
    
    return useQuery<IListFgaRolesQuery, TError, TData>(
      variables === undefined ? ['listFGARoles'] : ['listFGARoles', variables],
      useCodegenFetcher<IListFgaRolesQuery, IListFgaRolesQueryVariables>(ListFgaRolesDocument).bind(null, variables),
      options
    )};

useListFgaRolesQuery.getKey = (variables?: IListFgaRolesQueryVariables) => variables === undefined ? ['listFGARoles'] : ['listFGARoles', variables];

export const useInfiniteListFgaRolesQuery = <
      TData = IListFgaRolesQuery,
      TError = unknown
    >(
      variables?: IListFgaRolesQueryVariables,
      options?: UseInfiniteQueryOptions<IListFgaRolesQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IListFgaRolesQuery, IListFgaRolesQueryVariables>(ListFgaRolesDocument)
    return useInfiniteQuery<IListFgaRolesQuery, TError, TData>(
      variables === undefined ? ['listFGARoles.infinite'] : ['listFGARoles.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteListFgaRolesQuery.getKey = (variables?: IListFgaRolesQueryVariables) => variables === undefined ? ['listFGARoles.infinite'] : ['listFGARoles.infinite', variables];

export const ListFgaSiteTrialsDocument = /*#__PURE__*/ `
    query ListFGASiteTrials($input: Fga__ListResourcesInput!) {
  Fga__listResources(input: $input) {
    edges {
      resource(allSiteTrials: true) {
        __typename
        ... on SiteTrial {
          site {
            id
            name
            number
          }
          sponsorTrial(allTrials: true) {
            name
            stId
          }
          studyteamId
        }
      }
    }
  }
}
    `;

export const useListFgaSiteTrialsQuery = <
      TData = IListFgaSiteTrialsQuery,
      TError = unknown
    >(
      variables: IListFgaSiteTrialsQueryVariables,
      options?: UseQueryOptions<IListFgaSiteTrialsQuery, TError, TData>
    ) => {
    
    return useQuery<IListFgaSiteTrialsQuery, TError, TData>(
      ['ListFGASiteTrials', variables],
      useCodegenFetcher<IListFgaSiteTrialsQuery, IListFgaSiteTrialsQueryVariables>(ListFgaSiteTrialsDocument).bind(null, variables),
      options
    )};

useListFgaSiteTrialsQuery.getKey = (variables: IListFgaSiteTrialsQueryVariables) => ['ListFGASiteTrials', variables];

export const useInfiniteListFgaSiteTrialsQuery = <
      TData = IListFgaSiteTrialsQuery,
      TError = unknown
    >(
      variables: IListFgaSiteTrialsQueryVariables,
      options?: UseInfiniteQueryOptions<IListFgaSiteTrialsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IListFgaSiteTrialsQuery, IListFgaSiteTrialsQueryVariables>(ListFgaSiteTrialsDocument)
    return useInfiniteQuery<IListFgaSiteTrialsQuery, TError, TData>(
      ['ListFGASiteTrials.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteListFgaSiteTrialsQuery.getKey = (variables: IListFgaSiteTrialsQueryVariables) => ['ListFGASiteTrials.infinite', variables];

export const ListUploadNamesDocument = /*#__PURE__*/ `
    query listUploadNames($input: ListUploadNamesInput!) {
  listUploadNames(input: $input) {
    name
  }
}
    `;

export const useListUploadNamesQuery = <
      TData = IListUploadNamesQuery,
      TError = unknown
    >(
      variables: IListUploadNamesQueryVariables,
      options?: UseQueryOptions<IListUploadNamesQuery, TError, TData>
    ) => {
    
    return useQuery<IListUploadNamesQuery, TError, TData>(
      ['listUploadNames', variables],
      useCodegenFetcher<IListUploadNamesQuery, IListUploadNamesQueryVariables>(ListUploadNamesDocument).bind(null, variables),
      options
    )};

useListUploadNamesQuery.getKey = (variables: IListUploadNamesQueryVariables) => ['listUploadNames', variables];

export const useInfiniteListUploadNamesQuery = <
      TData = IListUploadNamesQuery,
      TError = unknown
    >(
      variables: IListUploadNamesQueryVariables,
      options?: UseInfiniteQueryOptions<IListUploadNamesQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IListUploadNamesQuery, IListUploadNamesQueryVariables>(ListUploadNamesDocument)
    return useInfiniteQuery<IListUploadNamesQuery, TError, TData>(
      ['listUploadNames.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteListUploadNamesQuery.getKey = (variables: IListUploadNamesQueryVariables) => ['listUploadNames.infinite', variables];

export const RequestUpdatesForDocumentDocument = /*#__PURE__*/ `
    mutation requestUpdatesForDocument($input: RequestUpdatesForDocumentInput!) {
  data: requestUpdatesForDocument(input: $input) {
    error {
      message
      code
    }
  }
}
    `;

export const useRequestUpdatesForDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IRequestUpdatesForDocumentMutation, TError, IRequestUpdatesForDocumentMutationVariables, TContext>) => {
    
    return useMutation<IRequestUpdatesForDocumentMutation, TError, IRequestUpdatesForDocumentMutationVariables, TContext>(
      ['requestUpdatesForDocument'],
      useCodegenFetcher<IRequestUpdatesForDocumentMutation, IRequestUpdatesForDocumentMutationVariables>(RequestUpdatesForDocumentDocument),
      options
    )};

useRequestUpdatesForDocumentMutation.getKey = () => ['requestUpdatesForDocument'];

export const CreateSignatureAssignmentDocument = /*#__PURE__*/ `
    mutation createSignatureAssignment($input: CreateSignatureAssignmentInput!) {
  data: createSignatureAssignment(input: $input) {
    error {
      message
      code
    }
  }
}
    `;

export const useCreateSignatureAssignmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ICreateSignatureAssignmentMutation, TError, ICreateSignatureAssignmentMutationVariables, TContext>) => {
    
    return useMutation<ICreateSignatureAssignmentMutation, TError, ICreateSignatureAssignmentMutationVariables, TContext>(
      ['createSignatureAssignment'],
      useCodegenFetcher<ICreateSignatureAssignmentMutation, ICreateSignatureAssignmentMutationVariables>(CreateSignatureAssignmentDocument),
      options
    )};

useCreateSignatureAssignmentMutation.getKey = () => ['createSignatureAssignment'];

export const UpdateSignatureAssignmentDocument = /*#__PURE__*/ `
    mutation updateSignatureAssignment($input: UpdateSignatureAssignmentInput!) {
  data: updateSignatureAssignment(input: $input) {
    error {
      message
      code
    }
  }
}
    `;

export const useUpdateSignatureAssignmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IUpdateSignatureAssignmentMutation, TError, IUpdateSignatureAssignmentMutationVariables, TContext>) => {
    
    return useMutation<IUpdateSignatureAssignmentMutation, TError, IUpdateSignatureAssignmentMutationVariables, TContext>(
      ['updateSignatureAssignment'],
      useCodegenFetcher<IUpdateSignatureAssignmentMutation, IUpdateSignatureAssignmentMutationVariables>(UpdateSignatureAssignmentDocument),
      options
    )};

useUpdateSignatureAssignmentMutation.getKey = () => ['updateSignatureAssignment'];

export const UnassignSignatureDocument = /*#__PURE__*/ `
    mutation unassignSignature($input: UnassignSignatureInput!) {
  data: unassignSignature(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

export const useUnassignSignatureMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IUnassignSignatureMutation, TError, IUnassignSignatureMutationVariables, TContext>) => {
    
    return useMutation<IUnassignSignatureMutation, TError, IUnassignSignatureMutationVariables, TContext>(
      ['unassignSignature'],
      useCodegenFetcher<IUnassignSignatureMutation, IUnassignSignatureMutationVariables>(UnassignSignatureDocument),
      options
    )};

useUnassignSignatureMutation.getKey = () => ['unassignSignature'];

export const CreateExpectedSourceDocumentUploadDocument = /*#__PURE__*/ `
    mutation CreateExpectedSourceDocumentUpload($input: CreateExpectedSourceDocumentUploadInput!) {
  createExpectedSourceDocumentUpload(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

export const useCreateExpectedSourceDocumentUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ICreateExpectedSourceDocumentUploadMutation, TError, ICreateExpectedSourceDocumentUploadMutationVariables, TContext>) => {
    
    return useMutation<ICreateExpectedSourceDocumentUploadMutation, TError, ICreateExpectedSourceDocumentUploadMutationVariables, TContext>(
      ['CreateExpectedSourceDocumentUpload'],
      useCodegenFetcher<ICreateExpectedSourceDocumentUploadMutation, ICreateExpectedSourceDocumentUploadMutationVariables>(CreateExpectedSourceDocumentUploadDocument),
      options
    )};

useCreateExpectedSourceDocumentUploadMutation.getKey = () => ['CreateExpectedSourceDocumentUpload'];

export const DeleteExpectedSourceDocumentUploadDocument = /*#__PURE__*/ `
    mutation DeleteExpectedSourceDocumentUpload($input: DeleteExpectedSourceDocumentUploadInput!) {
  deleteExpectedSourceDocumentUpload(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

export const useDeleteExpectedSourceDocumentUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IDeleteExpectedSourceDocumentUploadMutation, TError, IDeleteExpectedSourceDocumentUploadMutationVariables, TContext>) => {
    
    return useMutation<IDeleteExpectedSourceDocumentUploadMutation, TError, IDeleteExpectedSourceDocumentUploadMutationVariables, TContext>(
      ['DeleteExpectedSourceDocumentUpload'],
      useCodegenFetcher<IDeleteExpectedSourceDocumentUploadMutation, IDeleteExpectedSourceDocumentUploadMutationVariables>(DeleteExpectedSourceDocumentUploadDocument),
      options
    )};

useDeleteExpectedSourceDocumentUploadMutation.getKey = () => ['DeleteExpectedSourceDocumentUpload'];

export const UpdateExpectedSourceDocumentUploadDocument = /*#__PURE__*/ `
    mutation UpdateExpectedSourceDocumentUpload($input: UpdateExpectedSourceDocumentUploadInput!) {
  updateExpectedSourceDocumentUpload(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

export const useUpdateExpectedSourceDocumentUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IUpdateExpectedSourceDocumentUploadMutation, TError, IUpdateExpectedSourceDocumentUploadMutationVariables, TContext>) => {
    
    return useMutation<IUpdateExpectedSourceDocumentUploadMutation, TError, IUpdateExpectedSourceDocumentUploadMutationVariables, TContext>(
      ['UpdateExpectedSourceDocumentUpload'],
      useCodegenFetcher<IUpdateExpectedSourceDocumentUploadMutation, IUpdateExpectedSourceDocumentUploadMutationVariables>(UpdateExpectedSourceDocumentUploadDocument),
      options
    )};

useUpdateExpectedSourceDocumentUploadMutation.getKey = () => ['UpdateExpectedSourceDocumentUpload'];

export const ListInvestigatorsDocument = /*#__PURE__*/ `
    query listInvestigators($input: ListInvestigatorsInput!) {
  data: listInvestigators(input: $input) {
    id
    fullName
    email
  }
}
    `;

export const useListInvestigatorsQuery = <
      TData = IListInvestigatorsQuery,
      TError = unknown
    >(
      variables: IListInvestigatorsQueryVariables,
      options?: UseQueryOptions<IListInvestigatorsQuery, TError, TData>
    ) => {
    
    return useQuery<IListInvestigatorsQuery, TError, TData>(
      ['listInvestigators', variables],
      useCodegenFetcher<IListInvestigatorsQuery, IListInvestigatorsQueryVariables>(ListInvestigatorsDocument).bind(null, variables),
      options
    )};

useListInvestigatorsQuery.getKey = (variables: IListInvestigatorsQueryVariables) => ['listInvestigators', variables];

export const useInfiniteListInvestigatorsQuery = <
      TData = IListInvestigatorsQuery,
      TError = unknown
    >(
      variables: IListInvestigatorsQueryVariables,
      options?: UseInfiniteQueryOptions<IListInvestigatorsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IListInvestigatorsQuery, IListInvestigatorsQueryVariables>(ListInvestigatorsDocument)
    return useInfiniteQuery<IListInvestigatorsQuery, TError, TData>(
      ['listInvestigators.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteListInvestigatorsQuery.getKey = (variables: IListInvestigatorsQueryVariables) => ['listInvestigators.infinite', variables];

export const DocumentSignatureAssignmentDocument = /*#__PURE__*/ `
    query documentSignatureAssignment($input: SignatureAssignmentInput!) {
  data: signatureAssignment(input: $input) {
    assignee {
      id
      email
      fullName
    }
    assigner {
      id
      email
      fullName
    }
    priority
    lastNotified {
      recipient {
        fullName
        email
      }
      sentAt
    }
    createdAt
    id
    note
  }
}
    `;

export const useDocumentSignatureAssignmentQuery = <
      TData = IDocumentSignatureAssignmentQuery,
      TError = unknown
    >(
      variables: IDocumentSignatureAssignmentQueryVariables,
      options?: UseQueryOptions<IDocumentSignatureAssignmentQuery, TError, TData>
    ) => {
    
    return useQuery<IDocumentSignatureAssignmentQuery, TError, TData>(
      ['documentSignatureAssignment', variables],
      useCodegenFetcher<IDocumentSignatureAssignmentQuery, IDocumentSignatureAssignmentQueryVariables>(DocumentSignatureAssignmentDocument).bind(null, variables),
      options
    )};

useDocumentSignatureAssignmentQuery.getKey = (variables: IDocumentSignatureAssignmentQueryVariables) => ['documentSignatureAssignment', variables];

export const useInfiniteDocumentSignatureAssignmentQuery = <
      TData = IDocumentSignatureAssignmentQuery,
      TError = unknown
    >(
      variables: IDocumentSignatureAssignmentQueryVariables,
      options?: UseInfiniteQueryOptions<IDocumentSignatureAssignmentQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IDocumentSignatureAssignmentQuery, IDocumentSignatureAssignmentQueryVariables>(DocumentSignatureAssignmentDocument)
    return useInfiniteQuery<IDocumentSignatureAssignmentQuery, TError, TData>(
      ['documentSignatureAssignment.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteDocumentSignatureAssignmentQuery.getKey = (variables: IDocumentSignatureAssignmentQueryVariables) => ['documentSignatureAssignment.infinite', variables];

export const DocumentDetailsForAssignmentQueueDocument = /*#__PURE__*/ `
    query documentDetailsForAssignmentQueue($input: GetSourceDocumentDetailsInput!) {
  data: documentDetails(input: $input) {
    filledInForm {
      id
      blankForm {
        id
      }
    }
    id
    name
    piSigned
    patientVisits {
      patientVisitId: id
      ... on UnscheduledPatientProtocolVisit {
        __typename
        name
        id: visitId
      }
      ... on PatientProtocolVisit {
        __typename
        protocolVisit {
          id
          name
        }
      }
    }
    documentType
    subjectId
    signatures {
      typeface
      userId
      note
      reason
      id
      fullName
      timestamp
      documentVersion
      signatureRole
    }
    status
    updateRequest {
      note
      timestamp
      user {
        fullName
      }
    }
    openQueriesCount
    reviewer {
      id
      fullName
    }
    qcWorkflowStatus
    revisionAssignee {
      fullName
    }
    signed
    siteTrialPatient {
      id
    }
    closedQueriesCount
    uploader {
      fullName
    }
    piSignatureRequired
    signatureInvalidations {
      id
      timestamp
    }
    userCanApproveAndSign
    workflowStatus
    trialSource
    uploadedAt
    version
    partial
    originalDate
    confirmed
    documentModifiedAt
  }
}
    `;

export const useDocumentDetailsForAssignmentQueueQuery = <
      TData = IDocumentDetailsForAssignmentQueueQuery,
      TError = unknown
    >(
      variables: IDocumentDetailsForAssignmentQueueQueryVariables,
      options?: UseQueryOptions<IDocumentDetailsForAssignmentQueueQuery, TError, TData>
    ) => {
    
    return useQuery<IDocumentDetailsForAssignmentQueueQuery, TError, TData>(
      ['documentDetailsForAssignmentQueue', variables],
      useCodegenFetcher<IDocumentDetailsForAssignmentQueueQuery, IDocumentDetailsForAssignmentQueueQueryVariables>(DocumentDetailsForAssignmentQueueDocument).bind(null, variables),
      options
    )};

useDocumentDetailsForAssignmentQueueQuery.getKey = (variables: IDocumentDetailsForAssignmentQueueQueryVariables) => ['documentDetailsForAssignmentQueue', variables];

export const useInfiniteDocumentDetailsForAssignmentQueueQuery = <
      TData = IDocumentDetailsForAssignmentQueueQuery,
      TError = unknown
    >(
      variables: IDocumentDetailsForAssignmentQueueQueryVariables,
      options?: UseInfiniteQueryOptions<IDocumentDetailsForAssignmentQueueQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IDocumentDetailsForAssignmentQueueQuery, IDocumentDetailsForAssignmentQueueQueryVariables>(DocumentDetailsForAssignmentQueueDocument)
    return useInfiniteQuery<IDocumentDetailsForAssignmentQueueQuery, TError, TData>(
      ['documentDetailsForAssignmentQueue.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteDocumentDetailsForAssignmentQueueQuery.getKey = (variables: IDocumentDetailsForAssignmentQueueQueryVariables) => ['documentDetailsForAssignmentQueue.infinite', variables];

export const DocumentDetailsForExportDdcDocument = /*#__PURE__*/ `
    query documentDetailsForExportDDC($input: GetSourceDocumentDetailsInput!) {
  data: documentDetails(input: $input) {
    siteTrialPatient {
      id
    }
    filledInForm {
      id
    }
    name
    subjectId
    signatureInvalidations {
      id
      timestamp
    }
    patientVisits {
      __typename
      id
      type
      ... on PatientProtocolVisit {
        __typename
        protocolVisit {
          track
          name
          crossVersionId
          visitWindow {
            fromDate
            toDate
            targetDate
          }
          scheduled {
            visitId
            date
          }
        }
      }
      ... on UnscheduledPatientProtocolVisit {
        __typename
        name
        track
        date
      }
    }
  }
}
    `;

export const useDocumentDetailsForExportDdcQuery = <
      TData = IDocumentDetailsForExportDdcQuery,
      TError = unknown
    >(
      variables: IDocumentDetailsForExportDdcQueryVariables,
      options?: UseQueryOptions<IDocumentDetailsForExportDdcQuery, TError, TData>
    ) => {
    
    return useQuery<IDocumentDetailsForExportDdcQuery, TError, TData>(
      ['documentDetailsForExportDDC', variables],
      useCodegenFetcher<IDocumentDetailsForExportDdcQuery, IDocumentDetailsForExportDdcQueryVariables>(DocumentDetailsForExportDdcDocument).bind(null, variables),
      options
    )};

useDocumentDetailsForExportDdcQuery.getKey = (variables: IDocumentDetailsForExportDdcQueryVariables) => ['documentDetailsForExportDDC', variables];

export const useInfiniteDocumentDetailsForExportDdcQuery = <
      TData = IDocumentDetailsForExportDdcQuery,
      TError = unknown
    >(
      variables: IDocumentDetailsForExportDdcQueryVariables,
      options?: UseInfiniteQueryOptions<IDocumentDetailsForExportDdcQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IDocumentDetailsForExportDdcQuery, IDocumentDetailsForExportDdcQueryVariables>(DocumentDetailsForExportDdcDocument)
    return useInfiniteQuery<IDocumentDetailsForExportDdcQuery, TError, TData>(
      ['documentDetailsForExportDDC.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteDocumentDetailsForExportDdcQuery.getKey = (variables: IDocumentDetailsForExportDdcQueryVariables) => ['documentDetailsForExportDDC.infinite', variables];

export const ListAssignedInvestigatorDocumentsDocument = /*#__PURE__*/ `
    query listAssignedInvestigatorDocuments($input: ListDocumentsAssignedToUserInput!) {
  documents: listAssignedInvestigatorDocuments(input: $input) {
    edges {
      node {
        id
        name
        subjectId
        signatureAssignment {
          priority
        }
        patientVisits {
          id
          type
          ... on PatientProtocolVisit {
            __typename
            siteTrialPatient {
              id
            }
            protocolVisit {
              track
              name
              crossVersionId
              visitWindow {
                fromDate
                toDate
                targetDate
              }
              scheduled {
                visitId
                date
              }
            }
          }
          ... on UnscheduledPatientProtocolVisit {
            __typename
            name
            siteTrialPatient {
              id
            }
            track
            date
          }
        }
      }
    }
  }
}
    `;

export const useListAssignedInvestigatorDocumentsQuery = <
      TData = IListAssignedInvestigatorDocumentsQuery,
      TError = unknown
    >(
      variables: IListAssignedInvestigatorDocumentsQueryVariables,
      options?: UseQueryOptions<IListAssignedInvestigatorDocumentsQuery, TError, TData>
    ) => {
    
    return useQuery<IListAssignedInvestigatorDocumentsQuery, TError, TData>(
      ['listAssignedInvestigatorDocuments', variables],
      useCodegenFetcher<IListAssignedInvestigatorDocumentsQuery, IListAssignedInvestigatorDocumentsQueryVariables>(ListAssignedInvestigatorDocumentsDocument).bind(null, variables),
      options
    )};

useListAssignedInvestigatorDocumentsQuery.getKey = (variables: IListAssignedInvestigatorDocumentsQueryVariables) => ['listAssignedInvestigatorDocuments', variables];

export const useInfiniteListAssignedInvestigatorDocumentsQuery = <
      TData = IListAssignedInvestigatorDocumentsQuery,
      TError = unknown
    >(
      variables: IListAssignedInvestigatorDocumentsQueryVariables,
      options?: UseInfiniteQueryOptions<IListAssignedInvestigatorDocumentsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IListAssignedInvestigatorDocumentsQuery, IListAssignedInvestigatorDocumentsQueryVariables>(ListAssignedInvestigatorDocumentsDocument)
    return useInfiniteQuery<IListAssignedInvestigatorDocumentsQuery, TError, TData>(
      ['listAssignedInvestigatorDocuments.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteListAssignedInvestigatorDocumentsQuery.getKey = (variables: IListAssignedInvestigatorDocumentsQueryVariables) => ['listAssignedInvestigatorDocuments.infinite', variables];

export const ListAllInvestigatorDocumentsDocument = /*#__PURE__*/ `
    query listAllInvestigatorDocuments($input: ListAllInvestigatorDocumentsInput!) {
  documents: listAllInvestigatorDocuments(input: $input) {
    edges {
      node {
        id
        name
        subjectId
        signatureAssignment {
          priority
        }
        patientVisits {
          id
          type
          ... on PatientProtocolVisit {
            __typename
            protocolVisit {
              track
              name
              crossVersionId
              visitWindow {
                fromDate
                toDate
                targetDate
              }
              scheduled {
                visitId
                date
              }
            }
          }
          ... on UnscheduledPatientProtocolVisit {
            __typename
            name
            track
            date
          }
        }
      }
    }
  }
}
    `;

export const useListAllInvestigatorDocumentsQuery = <
      TData = IListAllInvestigatorDocumentsQuery,
      TError = unknown
    >(
      variables: IListAllInvestigatorDocumentsQueryVariables,
      options?: UseQueryOptions<IListAllInvestigatorDocumentsQuery, TError, TData>
    ) => {
    
    return useQuery<IListAllInvestigatorDocumentsQuery, TError, TData>(
      ['listAllInvestigatorDocuments', variables],
      useCodegenFetcher<IListAllInvestigatorDocumentsQuery, IListAllInvestigatorDocumentsQueryVariables>(ListAllInvestigatorDocumentsDocument).bind(null, variables),
      options
    )};

useListAllInvestigatorDocumentsQuery.getKey = (variables: IListAllInvestigatorDocumentsQueryVariables) => ['listAllInvestigatorDocuments', variables];

export const useInfiniteListAllInvestigatorDocumentsQuery = <
      TData = IListAllInvestigatorDocumentsQuery,
      TError = unknown
    >(
      variables: IListAllInvestigatorDocumentsQueryVariables,
      options?: UseInfiniteQueryOptions<IListAllInvestigatorDocumentsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IListAllInvestigatorDocumentsQuery, IListAllInvestigatorDocumentsQueryVariables>(ListAllInvestigatorDocumentsDocument)
    return useInfiniteQuery<IListAllInvestigatorDocumentsQuery, TError, TData>(
      ['listAllInvestigatorDocuments.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteListAllInvestigatorDocumentsQuery.getKey = (variables: IListAllInvestigatorDocumentsQueryVariables) => ['listAllInvestigatorDocuments.infinite', variables];

export const SourceAccessInfoDocument = /*#__PURE__*/ `
    query sourceAccessInfo {
  sourceAccessInfo {
    hasAccess
  }
}
    `;

export const useSourceAccessInfoQuery = <
      TData = ISourceAccessInfoQuery,
      TError = unknown
    >(
      variables?: ISourceAccessInfoQueryVariables,
      options?: UseQueryOptions<ISourceAccessInfoQuery, TError, TData>
    ) => {
    
    return useQuery<ISourceAccessInfoQuery, TError, TData>(
      variables === undefined ? ['sourceAccessInfo'] : ['sourceAccessInfo', variables],
      useCodegenFetcher<ISourceAccessInfoQuery, ISourceAccessInfoQueryVariables>(SourceAccessInfoDocument).bind(null, variables),
      options
    )};

useSourceAccessInfoQuery.getKey = (variables?: ISourceAccessInfoQueryVariables) => variables === undefined ? ['sourceAccessInfo'] : ['sourceAccessInfo', variables];

export const useInfiniteSourceAccessInfoQuery = <
      TData = ISourceAccessInfoQuery,
      TError = unknown
    >(
      variables?: ISourceAccessInfoQueryVariables,
      options?: UseInfiniteQueryOptions<ISourceAccessInfoQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<ISourceAccessInfoQuery, ISourceAccessInfoQueryVariables>(SourceAccessInfoDocument)
    return useInfiniteQuery<ISourceAccessInfoQuery, TError, TData>(
      variables === undefined ? ['sourceAccessInfo.infinite'] : ['sourceAccessInfo.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteSourceAccessInfoQuery.getKey = (variables?: ISourceAccessInfoQueryVariables) => variables === undefined ? ['sourceAccessInfo.infinite'] : ['sourceAccessInfo.infinite', variables];

export const ListSourceEnabledUserSiteTrialsDocument = /*#__PURE__*/ `
    query listSourceEnabledUserSiteTrials($input: ListSourceEnabledUserSiteTrialsInput!, $allTrials: Boolean!) {
  listSourceEnabledUserSiteTrials(input: $input) {
    edges {
      node {
        studyteamId
        site {
          id
          name
        }
        sponsorTrial(allTrials: $allTrials) {
          stId
          name
        }
        name
      }
    }
  }
}
    `;

export const useListSourceEnabledUserSiteTrialsQuery = <
      TData = IListSourceEnabledUserSiteTrialsQuery,
      TError = unknown
    >(
      variables: IListSourceEnabledUserSiteTrialsQueryVariables,
      options?: UseQueryOptions<IListSourceEnabledUserSiteTrialsQuery, TError, TData>
    ) => {
    
    return useQuery<IListSourceEnabledUserSiteTrialsQuery, TError, TData>(
      ['listSourceEnabledUserSiteTrials', variables],
      useCodegenFetcher<IListSourceEnabledUserSiteTrialsQuery, IListSourceEnabledUserSiteTrialsQueryVariables>(ListSourceEnabledUserSiteTrialsDocument).bind(null, variables),
      options
    )};

useListSourceEnabledUserSiteTrialsQuery.getKey = (variables: IListSourceEnabledUserSiteTrialsQueryVariables) => ['listSourceEnabledUserSiteTrials', variables];

export const useInfiniteListSourceEnabledUserSiteTrialsQuery = <
      TData = IListSourceEnabledUserSiteTrialsQuery,
      TError = unknown
    >(
      variables: IListSourceEnabledUserSiteTrialsQueryVariables,
      options?: UseInfiniteQueryOptions<IListSourceEnabledUserSiteTrialsQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IListSourceEnabledUserSiteTrialsQuery, IListSourceEnabledUserSiteTrialsQueryVariables>(ListSourceEnabledUserSiteTrialsDocument)
    return useInfiniteQuery<IListSourceEnabledUserSiteTrialsQuery, TError, TData>(
      ['listSourceEnabledUserSiteTrials.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteListSourceEnabledUserSiteTrialsQuery.getKey = (variables: IListSourceEnabledUserSiteTrialsQueryVariables) => ['listSourceEnabledUserSiteTrials.infinite', variables];

export const ListProtocolsBySiteTrialPatientIdDocument = /*#__PURE__*/ `
    query listProtocolsBySiteTrialPatientId($siteTrialPatientId: ID!) {
  Site__GetProtocolsBySiteTrialPatientId(siteTrialPatientId: $siteTrialPatientId) {
    externalVersions {
      selectedTrack
      protocolExternalVersionId
      id
      siteTrialPatientProtocolId
    }
    id
    protocolId
    selectedProtocolExternalVersionId
  }
}
    `;

export const useListProtocolsBySiteTrialPatientIdQuery = <
      TData = IListProtocolsBySiteTrialPatientIdQuery,
      TError = unknown
    >(
      variables: IListProtocolsBySiteTrialPatientIdQueryVariables,
      options?: UseQueryOptions<IListProtocolsBySiteTrialPatientIdQuery, TError, TData>
    ) => {
    
    return useQuery<IListProtocolsBySiteTrialPatientIdQuery, TError, TData>(
      ['listProtocolsBySiteTrialPatientId', variables],
      useCodegenFetcher<IListProtocolsBySiteTrialPatientIdQuery, IListProtocolsBySiteTrialPatientIdQueryVariables>(ListProtocolsBySiteTrialPatientIdDocument).bind(null, variables),
      options
    )};

useListProtocolsBySiteTrialPatientIdQuery.getKey = (variables: IListProtocolsBySiteTrialPatientIdQueryVariables) => ['listProtocolsBySiteTrialPatientId', variables];

export const useInfiniteListProtocolsBySiteTrialPatientIdQuery = <
      TData = IListProtocolsBySiteTrialPatientIdQuery,
      TError = unknown
    >(
      variables: IListProtocolsBySiteTrialPatientIdQueryVariables,
      options?: UseInfiniteQueryOptions<IListProtocolsBySiteTrialPatientIdQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<IListProtocolsBySiteTrialPatientIdQuery, IListProtocolsBySiteTrialPatientIdQueryVariables>(ListProtocolsBySiteTrialPatientIdDocument)
    return useInfiniteQuery<IListProtocolsBySiteTrialPatientIdQuery, TError, TData>(
      ['listProtocolsBySiteTrialPatientId.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteListProtocolsBySiteTrialPatientIdQuery.getKey = (variables: IListProtocolsBySiteTrialPatientIdQueryVariables) => ['listProtocolsBySiteTrialPatientId.infinite', variables];

export const SitePatientDocument = /*#__PURE__*/ `
    query sitePatient($siteTrialPatientId: ID!) {
  siteTrialPatient(id: $siteTrialPatientId) {
    sitePatient {
      id
    }
  }
}
    `;

export const useSitePatientQuery = <
      TData = ISitePatientQuery,
      TError = unknown
    >(
      variables: ISitePatientQueryVariables,
      options?: UseQueryOptions<ISitePatientQuery, TError, TData>
    ) => {
    
    return useQuery<ISitePatientQuery, TError, TData>(
      ['sitePatient', variables],
      useCodegenFetcher<ISitePatientQuery, ISitePatientQueryVariables>(SitePatientDocument).bind(null, variables),
      options
    )};

useSitePatientQuery.getKey = (variables: ISitePatientQueryVariables) => ['sitePatient', variables];

export const useInfiniteSitePatientQuery = <
      TData = ISitePatientQuery,
      TError = unknown
    >(
      variables: ISitePatientQueryVariables,
      options?: UseInfiniteQueryOptions<ISitePatientQuery, TError, TData>
    ) => {
    const query = useCodegenFetcher<ISitePatientQuery, ISitePatientQueryVariables>(SitePatientDocument)
    return useInfiniteQuery<ISitePatientQuery, TError, TData>(
      ['sitePatient.infinite', variables],
      (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      options
    )};

useInfiniteSitePatientQuery.getKey = (variables: ISitePatientQueryVariables) => ['sitePatient.infinite', variables];


/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetProtocolDetailsQuery((req, res, ctx) => {
 *   const { protocolId } = req.variables;
 *   return res(
 *     ctx.data({ protocol })
 *   )
 * })
 */
export const mockGetProtocolDetailsQuery = (resolver: ResponseResolver<GraphQLRequest<IGetProtocolDetailsQueryVariables>, GraphQLContext<IGetProtocolDetailsQuery>, any>) =>
  graphql.query<IGetProtocolDetailsQuery, IGetProtocolDetailsQueryVariables>(
    'getProtocolDetails',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSourceDocumentsQuery((req, res, ctx) => {
 *   const { listSourceDocumentsInput } = req.variables;
 *   return res(
 *     ctx.data({ listSourceDocuments })
 *   )
 * })
 */
export const mockGetSourceDocumentsQuery = (resolver: ResponseResolver<GraphQLRequest<IGetSourceDocumentsQueryVariables>, GraphQLContext<IGetSourceDocumentsQuery>, any>) =>
  graphql.query<IGetSourceDocumentsQuery, IGetSourceDocumentsQueryVariables>(
    'getSourceDocuments',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSiteTrialPatientProtocolVisitsQuery((req, res, ctx) => {
 *   const { request, siteTrialPatientId } = req.variables;
 *   return res(
 *     ctx.data({ Site__GetSiteTrialPatientProtocolVisits })
 *   )
 * })
 */
export const mockGetSiteTrialPatientProtocolVisitsQuery = (resolver: ResponseResolver<GraphQLRequest<IGetSiteTrialPatientProtocolVisitsQueryVariables>, GraphQLContext<IGetSiteTrialPatientProtocolVisitsQuery>, any>) =>
  graphql.query<IGetSiteTrialPatientProtocolVisitsQuery, IGetSiteTrialPatientProtocolVisitsQueryVariables>(
    'getSiteTrialPatientProtocolVisits',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBulkCheckPermissionsQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ bulkCheckPermissions })
 *   )
 * })
 */
export const mockBulkCheckPermissionsQuery = (resolver: ResponseResolver<GraphQLRequest<IBulkCheckPermissionsQueryVariables>, GraphQLContext<IBulkCheckPermissionsQuery>, any>) =>
  graphql.query<IBulkCheckPermissionsQuery, IBulkCheckPermissionsQueryVariables>(
    'BulkCheckPermissions',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDocumentLogQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ documentLog })
 *   )
 * })
 */
export const mockDocumentLogQuery = (resolver: ResponseResolver<GraphQLRequest<IDocumentLogQueryVariables>, GraphQLContext<IDocumentLogQuery>, any>) =>
  graphql.query<IDocumentLogQuery, IDocumentLogQueryVariables>(
    'DocumentLog',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEdoaUserProfileQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ edoaUserProfile })
 *   )
 * })
 */
export const mockEdoaUserProfileQuery = (resolver: ResponseResolver<GraphQLRequest<IEdoaUserProfileQueryVariables>, GraphQLContext<IEdoaUserProfileQuery>, any>) =>
  graphql.query<IEdoaUserProfileQuery, IEdoaUserProfileQueryVariables>(
    'EdoaUserProfile',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListExpectedUploadQuery((req, res, ctx) => {
 *   const { req } = req.variables;
 *   return res(
 *     ctx.data({ listExpectedDocumentUploads })
 *   )
 * })
 */
export const mockListExpectedUploadQuery = (resolver: ResponseResolver<GraphQLRequest<IListExpectedUploadQueryVariables>, GraphQLContext<IListExpectedUploadQuery>, any>) =>
  graphql.query<IListExpectedUploadQuery, IListExpectedUploadQueryVariables>(
    'ListExpectedUpload',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetAllSourceDocumentsForSiteTrialPatientQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ listSourceDocuments })
 *   )
 * })
 */
export const mockGetAllSourceDocumentsForSiteTrialPatientQuery = (resolver: ResponseResolver<GraphQLRequest<IGetAllSourceDocumentsForSiteTrialPatientQueryVariables>, GraphQLContext<IGetAllSourceDocumentsForSiteTrialPatientQuery>, any>) =>
  graphql.query<IGetAllSourceDocumentsForSiteTrialPatientQuery, IGetAllSourceDocumentsForSiteTrialPatientQueryVariables>(
    'getAllSourceDocumentsForSiteTrialPatient',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPiSignatureCountsQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ signatureRequiredCount })
 *   )
 * })
 */
export const mockGetPiSignatureCountsQuery = (resolver: ResponseResolver<GraphQLRequest<IGetPiSignatureCountsQueryVariables>, GraphQLContext<IGetPiSignatureCountsQuery>, any>) =>
  graphql.query<IGetPiSignatureCountsQuery, IGetPiSignatureCountsQueryVariables>(
    'getPISignatureCounts',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSiteTrialDetailsQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ siteTrial })
 *   )
 * })
 */
export const mockGetSiteTrialDetailsQuery = (resolver: ResponseResolver<GraphQLRequest<IGetSiteTrialDetailsQueryVariables>, GraphQLContext<IGetSiteTrialDetailsQuery>, any>) =>
  graphql.query<IGetSiteTrialDetailsQuery, IGetSiteTrialDetailsQueryVariables>(
    'getSiteTrialDetails',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSiteTrialPatientProtocolVisitsForSiteTrialQuery((req, res, ctx) => {
 *   const { request } = req.variables;
 *   return res(
 *     ctx.data({ Site__GetSiteTrialPatientProtocolVisitsForSiteTrial })
 *   )
 * })
 */
export const mockGetSiteTrialPatientProtocolVisitsForSiteTrialQuery = (resolver: ResponseResolver<GraphQLRequest<IGetSiteTrialPatientProtocolVisitsForSiteTrialQueryVariables>, GraphQLContext<IGetSiteTrialPatientProtocolVisitsForSiteTrialQuery>, any>) =>
  graphql.query<IGetSiteTrialPatientProtocolVisitsForSiteTrialQuery, IGetSiteTrialPatientProtocolVisitsForSiteTrialQueryVariables>(
    'getSiteTrialPatientProtocolVisitsForSiteTrial',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery((req, res, ctx) => {
 *   const { request } = req.variables;
 *   return res(
 *     ctx.data({ Site__GetSiteTrialPatientProtocolVisitsForSiteTrial })
 *   )
 * })
 */
export const mockGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery = (resolver: ResponseResolver<GraphQLRequest<IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQueryVariables>, GraphQLContext<IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery>, any>) =>
  graphql.query<IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQuery, IGetSiteTrialPatientProtocolVisitsForSiteTrialByCraQueryVariables>(
    'getSiteTrialPatientProtocolVisitsForSiteTrialByCRA',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListBlankFormSetsQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ listBlankFormSets })
 *   )
 * })
 */
export const mockListBlankFormSetsQuery = (resolver: ResponseResolver<GraphQLRequest<IListBlankFormSetsQueryVariables>, GraphQLContext<IListBlankFormSetsQuery>, any>) =>
  graphql.query<IListBlankFormSetsQuery, IListBlankFormSetsQueryVariables>(
    'listBlankFormSets',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListRoleAssignmentsQuery((req, res, ctx) => {
 *   const { userId } = req.variables;
 *   return res(
 *     ctx.data({ user })
 *   )
 * })
 */
export const mockListRoleAssignmentsQuery = (resolver: ResponseResolver<GraphQLRequest<IListRoleAssignmentsQueryVariables>, GraphQLContext<IListRoleAssignmentsQuery>, any>) =>
  graphql.query<IListRoleAssignmentsQuery, IListRoleAssignmentsQueryVariables>(
    'listRoleAssignments',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListFgaRolesQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ Fga__listRoles })
 *   )
 * })
 */
export const mockListFgaRolesQuery = (resolver: ResponseResolver<GraphQLRequest<IListFgaRolesQueryVariables>, GraphQLContext<IListFgaRolesQuery>, any>) =>
  graphql.query<IListFgaRolesQuery, IListFgaRolesQueryVariables>(
    'listFGARoles',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListFgaSiteTrialsQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ Fga__listResources })
 *   )
 * })
 */
export const mockListFgaSiteTrialsQuery = (resolver: ResponseResolver<GraphQLRequest<IListFgaSiteTrialsQueryVariables>, GraphQLContext<IListFgaSiteTrialsQuery>, any>) =>
  graphql.query<IListFgaSiteTrialsQuery, IListFgaSiteTrialsQueryVariables>(
    'ListFGASiteTrials',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListUploadNamesQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ listUploadNames })
 *   )
 * })
 */
export const mockListUploadNamesQuery = (resolver: ResponseResolver<GraphQLRequest<IListUploadNamesQueryVariables>, GraphQLContext<IListUploadNamesQuery>, any>) =>
  graphql.query<IListUploadNamesQuery, IListUploadNamesQueryVariables>(
    'listUploadNames',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRequestUpdatesForDocumentMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ requestUpdatesForDocument })
 *   )
 * })
 */
export const mockRequestUpdatesForDocumentMutation = (resolver: ResponseResolver<GraphQLRequest<IRequestUpdatesForDocumentMutationVariables>, GraphQLContext<IRequestUpdatesForDocumentMutation>, any>) =>
  graphql.mutation<IRequestUpdatesForDocumentMutation, IRequestUpdatesForDocumentMutationVariables>(
    'requestUpdatesForDocument',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateSignatureAssignmentMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ createSignatureAssignment })
 *   )
 * })
 */
export const mockCreateSignatureAssignmentMutation = (resolver: ResponseResolver<GraphQLRequest<ICreateSignatureAssignmentMutationVariables>, GraphQLContext<ICreateSignatureAssignmentMutation>, any>) =>
  graphql.mutation<ICreateSignatureAssignmentMutation, ICreateSignatureAssignmentMutationVariables>(
    'createSignatureAssignment',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateSignatureAssignmentMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateSignatureAssignment })
 *   )
 * })
 */
export const mockUpdateSignatureAssignmentMutation = (resolver: ResponseResolver<GraphQLRequest<IUpdateSignatureAssignmentMutationVariables>, GraphQLContext<IUpdateSignatureAssignmentMutation>, any>) =>
  graphql.mutation<IUpdateSignatureAssignmentMutation, IUpdateSignatureAssignmentMutationVariables>(
    'updateSignatureAssignment',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUnassignSignatureMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ unassignSignature })
 *   )
 * })
 */
export const mockUnassignSignatureMutation = (resolver: ResponseResolver<GraphQLRequest<IUnassignSignatureMutationVariables>, GraphQLContext<IUnassignSignatureMutation>, any>) =>
  graphql.mutation<IUnassignSignatureMutation, IUnassignSignatureMutationVariables>(
    'unassignSignature',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateExpectedSourceDocumentUploadMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ createExpectedSourceDocumentUpload })
 *   )
 * })
 */
export const mockCreateExpectedSourceDocumentUploadMutation = (resolver: ResponseResolver<GraphQLRequest<ICreateExpectedSourceDocumentUploadMutationVariables>, GraphQLContext<ICreateExpectedSourceDocumentUploadMutation>, any>) =>
  graphql.mutation<ICreateExpectedSourceDocumentUploadMutation, ICreateExpectedSourceDocumentUploadMutationVariables>(
    'CreateExpectedSourceDocumentUpload',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteExpectedSourceDocumentUploadMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ deleteExpectedSourceDocumentUpload })
 *   )
 * })
 */
export const mockDeleteExpectedSourceDocumentUploadMutation = (resolver: ResponseResolver<GraphQLRequest<IDeleteExpectedSourceDocumentUploadMutationVariables>, GraphQLContext<IDeleteExpectedSourceDocumentUploadMutation>, any>) =>
  graphql.mutation<IDeleteExpectedSourceDocumentUploadMutation, IDeleteExpectedSourceDocumentUploadMutationVariables>(
    'DeleteExpectedSourceDocumentUpload',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateExpectedSourceDocumentUploadMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateExpectedSourceDocumentUpload })
 *   )
 * })
 */
export const mockUpdateExpectedSourceDocumentUploadMutation = (resolver: ResponseResolver<GraphQLRequest<IUpdateExpectedSourceDocumentUploadMutationVariables>, GraphQLContext<IUpdateExpectedSourceDocumentUploadMutation>, any>) =>
  graphql.mutation<IUpdateExpectedSourceDocumentUploadMutation, IUpdateExpectedSourceDocumentUploadMutationVariables>(
    'UpdateExpectedSourceDocumentUpload',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListInvestigatorsQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ listInvestigators })
 *   )
 * })
 */
export const mockListInvestigatorsQuery = (resolver: ResponseResolver<GraphQLRequest<IListInvestigatorsQueryVariables>, GraphQLContext<IListInvestigatorsQuery>, any>) =>
  graphql.query<IListInvestigatorsQuery, IListInvestigatorsQueryVariables>(
    'listInvestigators',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDocumentSignatureAssignmentQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ signatureAssignment })
 *   )
 * })
 */
export const mockDocumentSignatureAssignmentQuery = (resolver: ResponseResolver<GraphQLRequest<IDocumentSignatureAssignmentQueryVariables>, GraphQLContext<IDocumentSignatureAssignmentQuery>, any>) =>
  graphql.query<IDocumentSignatureAssignmentQuery, IDocumentSignatureAssignmentQueryVariables>(
    'documentSignatureAssignment',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDocumentDetailsForAssignmentQueueQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ documentDetails })
 *   )
 * })
 */
export const mockDocumentDetailsForAssignmentQueueQuery = (resolver: ResponseResolver<GraphQLRequest<IDocumentDetailsForAssignmentQueueQueryVariables>, GraphQLContext<IDocumentDetailsForAssignmentQueueQuery>, any>) =>
  graphql.query<IDocumentDetailsForAssignmentQueueQuery, IDocumentDetailsForAssignmentQueueQueryVariables>(
    'documentDetailsForAssignmentQueue',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDocumentDetailsForExportDdcQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ documentDetails })
 *   )
 * })
 */
export const mockDocumentDetailsForExportDdcQuery = (resolver: ResponseResolver<GraphQLRequest<IDocumentDetailsForExportDdcQueryVariables>, GraphQLContext<IDocumentDetailsForExportDdcQuery>, any>) =>
  graphql.query<IDocumentDetailsForExportDdcQuery, IDocumentDetailsForExportDdcQueryVariables>(
    'documentDetailsForExportDDC',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListAssignedInvestigatorDocumentsQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ listAssignedInvestigatorDocuments })
 *   )
 * })
 */
export const mockListAssignedInvestigatorDocumentsQuery = (resolver: ResponseResolver<GraphQLRequest<IListAssignedInvestigatorDocumentsQueryVariables>, GraphQLContext<IListAssignedInvestigatorDocumentsQuery>, any>) =>
  graphql.query<IListAssignedInvestigatorDocumentsQuery, IListAssignedInvestigatorDocumentsQueryVariables>(
    'listAssignedInvestigatorDocuments',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListAllInvestigatorDocumentsQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ listAllInvestigatorDocuments })
 *   )
 * })
 */
export const mockListAllInvestigatorDocumentsQuery = (resolver: ResponseResolver<GraphQLRequest<IListAllInvestigatorDocumentsQueryVariables>, GraphQLContext<IListAllInvestigatorDocumentsQuery>, any>) =>
  graphql.query<IListAllInvestigatorDocumentsQuery, IListAllInvestigatorDocumentsQueryVariables>(
    'listAllInvestigatorDocuments',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSourceAccessInfoQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ sourceAccessInfo })
 *   )
 * })
 */
export const mockSourceAccessInfoQuery = (resolver: ResponseResolver<GraphQLRequest<ISourceAccessInfoQueryVariables>, GraphQLContext<ISourceAccessInfoQuery>, any>) =>
  graphql.query<ISourceAccessInfoQuery, ISourceAccessInfoQueryVariables>(
    'sourceAccessInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListSourceEnabledUserSiteTrialsQuery((req, res, ctx) => {
 *   const { input, allTrials } = req.variables;
 *   return res(
 *     ctx.data({ listSourceEnabledUserSiteTrials })
 *   )
 * })
 */
export const mockListSourceEnabledUserSiteTrialsQuery = (resolver: ResponseResolver<GraphQLRequest<IListSourceEnabledUserSiteTrialsQueryVariables>, GraphQLContext<IListSourceEnabledUserSiteTrialsQuery>, any>) =>
  graphql.query<IListSourceEnabledUserSiteTrialsQuery, IListSourceEnabledUserSiteTrialsQueryVariables>(
    'listSourceEnabledUserSiteTrials',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockListProtocolsBySiteTrialPatientIdQuery((req, res, ctx) => {
 *   const { siteTrialPatientId } = req.variables;
 *   return res(
 *     ctx.data({ Site__GetProtocolsBySiteTrialPatientId })
 *   )
 * })
 */
export const mockListProtocolsBySiteTrialPatientIdQuery = (resolver: ResponseResolver<GraphQLRequest<IListProtocolsBySiteTrialPatientIdQueryVariables>, GraphQLContext<IListProtocolsBySiteTrialPatientIdQuery>, any>) =>
  graphql.query<IListProtocolsBySiteTrialPatientIdQuery, IListProtocolsBySiteTrialPatientIdQueryVariables>(
    'listProtocolsBySiteTrialPatientId',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSitePatientQuery((req, res, ctx) => {
 *   const { siteTrialPatientId } = req.variables;
 *   return res(
 *     ctx.data({ siteTrialPatient })
 *   )
 * })
 */
export const mockSitePatientQuery = (resolver: ResponseResolver<GraphQLRequest<ISitePatientQueryVariables>, GraphQLContext<ISitePatientQuery>, any>) =>
  graphql.query<ISitePatientQuery, ISitePatientQueryVariables>(
    'sitePatient',
    resolver
  )
